/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contact-us-page-container[_ngcontent-%COMP%]{min-width:1200px;padding:0 2rem}.contact-us-page-container[_ngcontent-%COMP%]   .centered[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.contact-us-page-container[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]{padding:1rem 2rem 2rem 3rem;font:1.6rem PoppinsThin,sans-serif}.contact-us-page-container[_ngcontent-%COMP%]   .profile-container[_ngcontent-%COMP%]{padding:0}.contact-us-page-container[_ngcontent-%COMP%]   .profile-container[_ngcontent-%COMP%]   .profile[_ngcontent-%COMP%]{width:100%;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;text-align:center}"];
export { styles as styles };
//# sourceMappingURL=contact-us-picture.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/contact-us/contact-us-picture/contact-us-picture.component.scss.shim.ngstyle.js
// module id = 1732
// module chunks = 27 28 29